import React from "react";
import Cards from "../components/Cards";
import Features from "../components/Features";
import CustomerSays from "../components/CustomerSays";
import Slider from "../components/Slider";
import "bootstrap/dist/css/bootstrap.min.css";

const HomePage = () => {
  return (
    <div>
      {/* Hero Section */}
      <Slider />

      {/* Features */}
      <Features />

      {/* Courses */}
      <Cards />

      {/* Featured Videos */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="display-5 fw-bold text-dark mb-3">
              Featured Explanatory Videos
            </h2>
            <p className="lead text-muted">
              Watch our most popular lessons and tutorials
            </p>
          </div>
          <div className="row g-4 justify-content-center">
            <div className="col-lg-6">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body p-4 text-center">
                  <div
                    className="bg-primary bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-4"
                    style={{ width: "80px", height: "80px" }}
                  >
                    <i className="bi bi-play-btn-fill text-primary fs-1"></i>
                  </div>
                  <h5 className="card-title fw-semibold">
                    Interactive Learning
                  </h5>
                  <p className="card-text text-muted">
                    Engaging video lessons with interactive exercises and
                    real-time feedback.
                  </p>
                  <button className="btn btn-outline-primary">
                    Watch Demo
                  </button>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body p-4 text-center">
                  <div
                    className="bg-success bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-4"
                    style={{ width: "80px", height: "80px" }}
                  >
                    <i className="bi bi-lightning-charge-fill text-success fs-1"></i>
                  </div>
                  <h5 className="card-title fw-semibold">Quick Concepts</h5>
                  <p className="card-text text-muted">
                    Bite-sized videos explaining complex concepts in simple,
                    easy-to-understand ways.
                  </p>
                  <button className="btn btn-outline-success">
                    Explore Videos
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <CustomerSays />

      {/* Footer CTA */}
      <footer className="py-5 bg-dark text-white">
        <div className="container text-center">
          <h3 className="fw-bold mb-3">Ready to Excel in Math?</h3>
          <p className="lead mb-4">
            Join Thousands of Students Achieving Their Goals Today!
          </p>
          <div className="d-flex justify-content-center gap-3 flex-wrap">
            <button className="btn btn-primary btn-lg d-flex align-items-center">
              <i className="bi bi-phone me-2"></i>
              Download Mobile App
            </button>
            <button className="btn btn-success btn-lg d-flex align-items-center">
              <i className="bi bi-person-plus me-2"></i>
              Sign Up Now
            </button>
          </div>
          <p className="text-muted mt-4 small">
            Start your learning journey with a 7-day free trial
          </p>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;
